import { PagedRequest } from "./PagedRequest";

export class PagedResult<T> extends PagedRequest {
  data: T[]
  totalCount: number
  totalPages: number
  highlightedPage?: number

  constructor(
    data: T[],
    totalCount: number,
    totalPages: number,
    pageNumber: number,
    pageSize: number,
    sortField?: string,
    sortDirection?: 'asc' | 'desc',
    highlightedPage?: number
  ) {
    super(pageNumber, pageSize, sortField, sortDirection)
    this.data = data
    this.totalCount = totalCount
    this.totalPages = totalPages
    this.highlightedPage = highlightedPage
  }

  static toPagedResult<T>(
    raw: any,
    Cls: new (data: any) => T
  ): PagedResult<T> {
    const items = raw.data.map((d: any) => new Cls(d));
    return new PagedResult<T>(
      items,
      raw.totalCount,
      raw.totalPages,
      raw.pageNumber,
      raw.pageSize,
      raw.sortField,
      raw.sortDirection
    );
  }

  static empty<T>(
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField?: string,
    sortDirection?: 'asc' | 'desc'
  ): PagedResult<T> {
    return new PagedResult<T>(
      [],
      0,
      0,
      pageNumber,
      pageSize,
      sortField,
      sortDirection
    );
  }
}